import { render, staticRenderFns } from "./remindRetireList.vue?vue&type=template&id=b190d0b8&scoped=true&"
import script from "./remindRetireList.vue?vue&type=script&lang=js&"
export * from "./remindRetireList.vue?vue&type=script&lang=js&"
import style0 from "./remindRetireList.vue?vue&type=style&index=0&id=b190d0b8&prod&scoped=true&lang=css&"
import style1 from "./remindRetireList.vue?vue&type=style&index=1&id=b190d0b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b190d0b8",
  null
  
)

export default component.exports